import type { TSafeAreaInsetValues } from './types'

const toPixels = (cssLength: string) => parseFloat(cssLength) || 0

export const parseSafeAreaInsets = (
  padding: Pick<CSSStyleDeclaration, 'paddingBottom' | 'paddingLeft' | 'paddingRight' | 'paddingTop'>,
): TSafeAreaInsetValues => ({
  top: toPixels(padding.paddingTop),
  right: toPixels(padding.paddingRight),
  bottom: toPixels(padding.paddingBottom),
  left: toPixels(padding.paddingLeft),
})
